import { render } from "./yimiao.vue?vue&type=template&id=3602b5b0&scoped=true"
import script from "./yimiao.vue?vue&type=script&lang=js"
export * from "./yimiao.vue?vue&type=script&lang=js"

import "./yimiao.vue?vue&type=style&index=0&id=3602b5b0&lang=scss&scoped=true"

import exportComponent from "D:\\project\\digital-signage-cockpit-40\\防疫数据驾驶舱4.0\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3602b5b0"]])

export default __exports__